export default {
  Menu: {
    Inicio: 'Home',
    Experiencias: 'Experiences',
    PorQueRegistrarse: 'Why Register',
    Asesoria: 'Consulting and Curatorship',
    EnviosYDevoluciones: 'Shipping & Returns',
    Faq: 'Frequently Asked Questions',
    TarjetaRegalo: 'Gift card',
    Alianzas: 'Alliances',
    Contactanos: 'Contact us',
    QuienesSomos: 'About us',
    TrabajaConNosotros: 'Work with us',
    Cookies: 'Cookies',
    Copyright: 'Copyright',
    PoliticaDePrivacidad: 'Privacy Policy',
    Disenadores: 'Designers',
    Artistas: 'Artists',
    Magazine: 'Magazine',
    Perfil: 'Profile',
    Carrito: 'Shopping Bag',
    Error404: 'Error 404',
    Acceso: 'Login',
    CerrarMenu: 'Close Menu',
    CerrarSesion: 'Log out',
    Administracion: 'Administration',
    Oficina: 'Back Office',
    ProductosOficina: 'Products',
    CapacitacionOficina: 'Training',
    VentasOficina: 'Sales',
    SoporteOficina: 'Support',
    Postulate: 'Present Yourself',
    Club: 'Club',
    Eventos: 'Events',
    Usuario: 'User',
    Articulo: 'Article',
    Empresas: 'Business',
    ConfirmarNewsletter: 'Confirm Newsletter',
    Producto: 'Product',
    PorQueComprar: 'Why Buy',
    Regalo: 'Gift Card',
    Tours: 'Artistic Tours',
    TyC: 'Terms and Conditions',
    Confirmación: 'Confirmation',
    GeneralPerfil: 'General',
    FavoritosPerfil: 'Favorites',
    PedidosPerfil: 'Orders',
    AdministracionGeneral: 'General',
    AdministracionAplicaciones: 'Applications',
    AdministracionMagazine: 'Magazine',
    AdministracionPaginas: 'Pages',
    AdministracionProductos: 'Products',
    AdministracionUsuarios: 'Users',
    AdministracionExperiencias: 'Experiences',
    AdministracionManual: 'Training',
    AdministracionContratos: 'Contracts',
    AdministracionCertificados: 'certificates',
    AdministracionPedidos: 'Orders',
    AdministracionPagos: 'Payments',
    AdministracionEntregaDinero: 'Give Money',
    AdministracionNewsletter: 'Newsletter',
    AdministracionCupones: 'Coupons',
    // new
    CreativeCommons: 'Creative Commons',
    CompraSegura: 'Secure purchase',
    CertificadoAutenticidad: 'Certificate of authenticity',
    EntregasInternacionales: 'International Deliveries',
    DíasDevoluciones: '5 days for returns',
    NecesitasAyuda: 'Need help?',
    ContactoTrArtist: 'Do you want to talk to someone on TrArtist?',
    BiografiaObras: 'Go to Biography and Works',
    Biografia: 'BIOGRAPHY',
    ReferenciaPersonal: 'Personal reference',
    ReferenciaProfesional: 'Professional reference',
    SubscripcionSletter: 'Subscribe to our Newsletter'
  },
  Alias: {
    Inicio: '/',
    PorQueRegistrarse: '/whyregister',
    Asesoria: '/advisory',
    EnviosYDevoluciones: '/shipping',
    Faq: '/faq',
    TarjetaRegalo: '/giftcard',
    Alianzas: '/alliances',
    Contactanos: '/contactus',
    QuienesSomos: '/aboutus',
    TrabajaConNosotros: '/workwithus',
    Cookies: '/cookies',
    Copyright: '/copyright',
    PoliticaDePrivacidad: '/privacy',
    Disenadores: '/designers',
    Artistas: '/artists',
    Magazine: '/magazine',
    Perfil: '/profile',
    Carrito: '/shoppingcart',
    Acceso: '/login',
    Administracion: '/administration',
    Oficina: '/backoffice',
    ProductosOficina: '/backoffice/products',
    CapacitacionOficina: '/backoffice/training',
    VentasOficina: '/backoffice/sells',
    SoporteOficina: '/backoffice/support',
    Postulate: '/apply',
    Eventos: '/events',
    Club: '/club',
    Articulo: '/article',
    Empresas: '/business',
    ConfirmarNewsletter: '/confirmnewsletter',
    Usuario: '/u',
    PorQueComprar: '/whybuy',
    Regalo: '/giftcard',
    Tours: '/tours',
    TyC: '/tyc',
    Confirmacion: '/confirmation',
    GeneralPerfil: '/profile/general',
    FavoritosPerfil: '/profile/favorites',
    PedidosPerfil: '/profile/orders',
    AdministracionGeneral: '/administration/general',
    AdministracionAplicaciones: '/administration/applications',
    AdministracionMagazine: '/administration/magazine',
    AdministracionPaginas: '/administration/pages',
    AdministracionProductos: '/administration/products',
    AdministracionUsuarios: '/administration/users',
    AdministracionExperiencias: '/administration/experiences',
    AdministracionManual: '/administration/training',
    AdministracionContratos: '/administration/contracts',
    AdministracionCertificados: '/administration/certificates',
    AdministracionPedidos: '/administration/orders',
    AdministracionPagos: '/administration/payments',
    AdministracionNewsletter: '/administration/newsletter',
    AdministracionCupones: '/administration/coupons',
    // new
    CreativeCommons: '/creativecommons'
  },
  SubMenus: {
    ParaCompradores: 'For buyers',
    ParaArtistas: 'For artists and designers',
    AcercaDe: 'About us',
    Trartist: 'TrArtist',
    Idioma: 'Language',
    Moneda: 'Currency',
    Productos: 'Products',
    Ventas: 'Sales',
    Capacitacion: 'Training',
    Soporte: 'Support'
  },
  Formularios: {
    Encargo: 'Product available on request',
    EncargoDias: 'Product available on request (days)',
    Vision: 'What vision do you have as an artist and/or designer in 5-10 and 15 years?',
    Camino: 'According to your way of understanding art and/or design, what would be the way to have a greater global artistic culture?',
    VerMas: 'See more',
    Salir: 'Exit',
    VerificarColor: '*We suggest you check the colors on various devices as they may vary.',
    MedidasProducto: 'Product Measurements',
    MedidasEmpacado: 'Product measurements Packaged',
    MedidasComoEmpacar: 'How do you want us to pack your artwork?',
    ObraBastidor: 'Work on the frame',
    ObraEnrollada: 'Rolled work',
    MensajeEnrollado: '* This packaging could reduce the cost of shipping',
    PrecioCOL: 'Price in Colombian pesos',
    PrecioUSD: 'Price in United States dollars (USD)',
    MiProductoIVA: 'My product invoices IVA',
    ValorNeto: 'Net amount to receive',
    ValorNetoUSD: 'Net amount to receive in USD',
    ComisionTrArtist: '35% TrArtist Commission',
    ComisionTrArtistUSD: '35% TrArtist Commission in USD',
    PrecioSinIva: 'Sale Price Without VAT',
    PrecioSinIvaUSD: 'Sale Price Without VAT in USD',
    IvaNeto: 'VAT 19% Net',
    IvaNetoUSD: 'VAT 19% Net in USD',
    PrecioPublicoCOL: 'Retail Price COL',
    PrecioPublicoUSD: 'Retail Price USD',
    VendedorRecibira: 'Seller will receive NET plus IVA',
    VendedorRecibiraUSD: 'Seller will receive NET plus IVA in USD',
    IvaVendedor: 'VAT that the seller will receive',
    IvaVendedorUSD: 'VAT that the seller will receive in USD',
    NuevoCupon: 'A new coupon will be generated with the remaining money',
    Cupon: 'Coupon',
    GuardarSinEnviar: 'Save Without Sending',
    EnviarAprobacion: 'Send for Approval',
    EliminarPerfil: 'Delete Profile Permanently',
    TituloEliminar: 'Delete my Profile',
    MensajeEliminar: 'This action is permanent and all the information related to you will be deleted, think twice because you cannot retrieve the information',
    PruebaEnvio: 'Upload a photo of the package sent',
    Etiquetas: 'Tags (Press Tab or Enter for the next)',
    Etiqueta: 'Tags',
    CampoRequerido: 'Required Field',
    Hora: 'Hour',
    Del: 'From',
    Al: 'To',
    IrEnlace: 'Go to Link',
    Certificado: 'Certificate of authenticity',
    Transportadora: 'Conveyor',
    Por: 'By',
    DireccionEntrega: 'Delivery address',
    Comprador: 'Buyer',
    SeleccionaColor: 'Select if your product contains colors or sizes',
    SeleccionaTipoMoneda: 'Select the type of currency for your product',
    PrecioDiaVenta: '* The money you will receive will be the one corresponding to the exchange rate of the day the sale is made, according to the amount that TrArtist has received',
    AgregaColor: 'Add the available colors and / or sizes first, then finish by placing the available inventory for each one',
    Tipo: 'Type',
    RevisarPedido: 'Check Order',
    DescargarProducto: 'Download Product',
    AdvertenciaImagenes: 'Upload maximum 2 images',
    Video: 'Link Video',
    Plataforma: 'Video Platform',
    ProductoEnviado: 'The Product has been dispatched',
    ProductoEmpacando: 'The Product is being packed',
    MarcarEnviado: 'Mark as sent',
    Guia: 'Shipping guide',
    Enviado: 'Dispatched',
    Desuscribirse: 'No more emails from TrArtist',
    Ver: 'See',
    VerContrato: 'See Contract',
    ContratoAprobado: 'Your Contract Has Been Approved',
    ContratoSubido: 'Your Contract is under review',
    Aprobado: 'Approved',
    Rechazado: 'Rejected',
    Pendiente: 'Pending',
    NoAprobado: 'Not Approved',
    HintNoAprobado: 'Complete all the information in your profile and sign the contract for your account to be approved',
    EnRevision: 'Your profile is under review',
    Secciones: 'Sections',
    NombreRequerido: 'Name Required',
    PseudonimoRequerido: 'Pseudonym Required',
    EmailRequerido: 'Email Required',
    EmailValido: 'E-mail must be valid',
    ContrasenaRequerido: 'Password Required',
    ContrasenaTamano: 'Password must have 6+ characters',
    TelefonoRequerido: 'Phone Required',
    PaisRequerido: 'Country Required',
    DepartamentoRequerido: 'Department Required',
    CiudadRequerido: 'City Required',
    CategoriaRequerido: 'Category Required',
    BiografiaRequerido: 'Biography Required',
    ComentarioDelModerador: 'Moderators Comment',
    Dimensiones: 'Dimensions',
    DimensionesEmpacado: 'Packaged Dimensions',
    DimensionesEnrollado: 'Rolled dimensions',
    Estado: 'Status',
    Producto: 'Product',
    RevisarProducto: 'Review Product',
    Autor: 'Author',
    DescripcionEs: 'Spanish Description',
    DescripcionEn: 'English Description',
    NuevaSeccion: 'New Section',
    EditarSeccion: 'Edit Section',
    Imagen: 'Image',
    NuevoMiembro: 'New Member',
    EditarMiembro: 'Edit Member',
    AbajoIzquierda: 'Down Left',
    AbajoDerecha: 'Down Right',
    Centro: 'Center',
    ArribaIzquierda: 'Up Left',
    ArribaDerecha: 'Up Right',
    MarcaDeAgua: 'Watermark',
    DescargarContrato: 'Download Contract',
    SubirContrato: 'Upload Contract',
    ArtistaODisenador: 'Artist or Designer',
    Registro: 'Register',
    Acceso: 'Log In',
    VerArticulo: 'See Article',
    VerPagina: 'See Page',
    Visitas: 'Views',
    TituloEs: 'Spanish Title',
    TituloEn: 'English Title',
    Guardar: 'Save',
    CargandoImagen: 'Loading image, wait a moment',
    NombreCompleto: 'Full Name',
    ResumenEs: 'Summary in Spanish',
    ResumenEn: 'Summary in English',
    ContenidoEs: 'Content in Spanish',
    ContenidoEn: 'Content in English',
    Estilo: 'Style',
    EstiloEn: 'Style in English',
    Formato: 'Format',
    Orientacion: 'Orientation',
    OrientacionEn: 'Orientation in English',
    Exponer: 'Exposing without Selling',
    Exhibicion: 'Product on Display',
    Referencia: 'Reference',
    Suscribirme: 'Subscribe',
    NuevoProducto: 'New product',
    EditarProducto: 'Edit product',
    Categoria: 'Category',
    CategoriaEn: 'Category in English',
    Disenador: 'Designer',
    Email: 'Email',
    Nombre: 'Full Name',
    Pseudonimo: 'Pseudonym or Brand',
    Telefono: 'Phone',
    TelefonoIndicativo: 'Mobile phone with country code',
    Pais: 'Country',
    Departamento: 'Department',
    Ciudad: 'City',
    Biografia: 'Biography and Exhibitions',
    BiografiaEs: 'Biography and Exhibitions in Spanish',
    BiografiaEn: 'Biography and Exhibitions in English',
    RedSocial: 'Social network',
    EnlaceRedSocial: 'Link',
    AnadirRedSocial: 'Add Social Network',
    IncluirRedSocial: 'Include Social Network',
    Red: 'Social Network',
    Enlace: 'Link',
    Acciones: 'Actions',
    FinalizarInscripcion: 'Finish Registration',
    Contrasena: 'Password',
    FinalizarRegistro: 'Finish Registration',
    IniciarSesion: 'Log In',
    Newsletter: 'I want to receive information, invitations and news from TrArtist',
    Soy: 'I am',
    Cliente: 'Client',
    Artista: 'Artist',
    Codigo: 'Code',
    ComprobarCodigo: 'Check Code',
    Postulate: 'Present yourself',
    AunNoTienesCodigo: 'Dont have your approval code yet?',
    TipoDeDocumento: 'Document type',
    DocumentoIdentificacion: 'Identification document',
    AdjuntarDocumento: 'Attach Identification Document',
    Direccion: 'Address',
    VideoYoutube: 'Link Youtube Video',
    FotoPerfil: 'Profile picture',
    Paypal: 'Paypal',
    CuentaDePaypal: 'Paypal account',
    ConsignacionBancaria: 'Bank deposit',
    AdjuntarCertificacion: 'Attach Bank Certification',
    CedulaCiudadania: 'Citizenship card',
    TarjetaIdentidad: 'Identity card',
    CedulaExtranjeria: 'Foreigner ID',
    Acepto: 'I Agree',
    NoAcepto: 'I Do Not Accept',
    TyC: 'I accept the terms and conditions of TrArtist.com',
    AdjuntaImagenes: 'Attach 3 images of your work',
    Imagenes: 'Images',
    Titulo: 'Title',
    Resumen: 'Summary',
    Descripcion: 'Description',
    EnlacePermanente: 'Permanent Link',
    EnlaceHint: 'trartist.com/magazine/link (No Spaces, Only dashes)',
    Publicar: 'Post',
    Actualizar: 'Update',
    Usuario: 'Username',
    HintUsuario: 'trartist.com/u/user (No spaces, only letters)',
    NuevaFoto: 'New Photo',
    Eliminar: 'Remove',
    VerPerfil: 'See my profile',
    Cerrar: 'Close',
    Editar: 'Edit',
    NuevoArticulo: 'New Article',
    EditarArticulo: 'Edit Article',
    Precio: 'Price',
    PrecioUnitario: 'Unit price',
    PrecioTotal: 'Total price',
    PrecioFinalCOP: 'Final Price COP',
    PrecioFinalUSD: 'Final Price USD',
    Cantidad: 'Quantity',
    ImagenPrincipal: 'Main Image',
    ImagenSecundaria: 'Secondary Image',
    ImagenesApoyo: 'Product Views',
    Largo: 'Length (cm)',
    Ancho: 'Width (cm)',
    Alto: 'Height (cm)',
    Peso: 'Weight (grams)',
    Enrollado: '',
    IncluirEnrollado: 'Include rolled packaging',
    MedidasEmpacadoEnrollado: 'Packaged Product Measurements (Rolled)',
    Digital: 'Digital Product',
    Fisico: 'Physical Product',
    ArchivoDigital: 'Digital File (A single .zip file)',
    Mes: 'Month',
    ZonaFisico: 'Physical Product Edition',
    ZonaDigital: 'Digital Product Edition',
    PrecioFisico: 'Physical Price',
    CantidadFisico: 'Physical Quantity',
    PrecioDigital: 'Digital Price',
    CantidadDigital: 'Digital Quantity',
    Ilimitado: 'Unlimited',
    MeGusta: 'Like',
    TextoEliminar: 'This action is permanent and once all your information is done it will be removed from the system.',
    OlvidasteContrasena: 'Did you forget your password?',
    Parrafo1: 'Paragraph  1',
    Parrafo2: 'Paragraph  2',
    Parrafo3: 'Paragraph  3',
    Subtitulo: 'Subtitle',
    ImagenParrafo: 'Image Paragraph',
    UsuarioSinProducto: 'This artist has not published products yet',
    CodigoPostal: 'Postal Code',
    Cuidados: 'Care',
    CuidadosEs: 'Care (Spanish)',
    CuidadosEn: 'Care (English)',
    Materiales: 'Materials',
    MaterialesEs: 'Materials (Spanish)',
    MaterialesEn: 'Materials (English)',
    Tecnica: 'Technique',
    TecnicaEs: 'Technique (Spanish)',
    TecnicaEn: 'Technique (English)',
    Talla: 'Size',
    AnadirTalla: 'Add Size',
    TablaTallas: 'Size chart',
    Color: 'Color',
    ColorEs: 'Color in Spanish',
    ColorEn: 'Color in English',
    EsRegalo: 'Its a gift or you want to send this product to another address',
    DireccionRegalo: 'Gift Address',
    DireccionComprador: 'Buyer Address',
    MedioDePago: 'Payment method',
    EnQueEresExperto: 'What are you an expert in? What do you excel at? What do you love to do?',
    ComoTrabajar: 'How can we work together?',
    Empresa: 'Business',
    CualEsTuPropuesta: 'Whats your proposal?',
    EnviarInformacion: 'Send information',
    ComoPodemosAyudarte: 'how can we help you?',
    Pagar: 'Pay',
    Bienvenido: 'Welcome',
    Privacidad: 'We take your privacy seriously and we will never share your data, you can change your mind at any time',
    TelefonoYWhatsapp: 'Phone and WhatsApp',
    AsuntoContacto: 'Contact #{uid} - {nombre}',
    ActualizacionPerfil: 'Perfil Update {nombre}',
    TextoActualizacionPerfil: '<span>Hello TrArtist Team,</span><br><br><span>{nombre} made changes to his profile and you can now review him. He made changes to his profile and you can now review it at TrArtist.com</span>',
    AsuntoAsesoria: 'Advisory #{uid} - {nombre}',
    TextoAsesoria: '<span>ID: {uid}</span><br><span>Name: {nombre}</span><br><span>City: {pais} - {departamento} - {ciudad}</span><br><span>Phone: {telefono}</span><br><span>Email: {correo}</span><br><span>Description: {descripcion}</span><br>',
    AsuntoAlianzas: 'Alliances #{uid} - {nombre}',
    TextoAlianzas: '<span>ID: {uid}</span><br><span>Name: {nombre}</span><br><span>Business: {empresa}</span><br><span>City: {pais} - {departamento} - {ciudad}</span><br><span>Phone: {telefono}</span><br><span>Email: {correo}</span><br><span>Description: {descripcion}</span><br>',
    AsuntoTrabaja: 'Work with us #{uid} - {nombre}',
    TextoTrabaja: '<span>ID: {uid}</span><br><span>Name: {nombre}</span><br><span>City: {pais} - {departamento} - {ciudad}</span><br><span>Phone: {telefono}</span><br><span>Email: {correo}</span><br><span>What are you expert at: {descripcion}</span><br><span>How to Work: {comoTrabajar}</span><br>',
    AsuntoAprobado: 'Your Product {titulo} has been Accepted',
    MensajeAprobado: '<span>Hello {nombre},</span><br><br><span>Your product {titulo} has been approved and is now available at <a href="trartist.com/p/{uid}">trartist.com</a></span>',
    AsuntoRechazado: 'Your product {titulo} has been Rejected',
    MensajeRechazado: '<span>Hello {nombre},</span><br><br><span>Your product {titulo} has been rejected for the following reason:</span><br><br><span>{comentario}</span>',
    AsuntoAprobadoArtista: 'Your Profile has been approved',
    MensajeAprobadoArtista: '<span>Hello {nombre},</span><br><br><span>Your profile has been approved and you can now start selling your products following the process and guidelines of the BackOffice training</span><br><span>{comentario}</span><br><br><span>Successes, regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoRechazadoArtista: 'Your Profile has not been approved',
    MensajeRechazadoArtista: '<span>Hola {nombre},</span><br><br><span>Your profile has not been approved for the following reason:</span><br><br><span>{comentario}</span><br><br><span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoPostulado: 'We have received your application',
    MensajePostulado: '<span>Hello {nombre},</span><br><br><span>We have received your application to be a member of TrArtist and we will give you the answer soon</span><br><br><span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    // New
    AceptarCreativeC: 'Do you want to add the Creative Commons License to this product? More info',
    AcogidoCreativeC: '* Work or design with Creative Commons License. More info',
    MasInformacion: 'More information:',
    Aqui: 'here',
    EnvioIncluido: 'Shipping cost included',
    ResenaEnglish: ' English Review',
    ResenaSpanish: ' Spanish Review',
    TipoMoneda: 'Type of Currency',
    CostoEnvio: 'Cost of shipping',
    SubiendoArchivoDigital: 'Uploading Digital File',
    SubiendoTablaTallas: 'Uploading Size Chart',
    ProcesandoImagenPrincipal: 'Processing Main Image',
    SubiendoImagenesSecundarias: 'Uploading Secondary Images',
    SubiendoProducto: 'Uploading Product',
    Descargar: 'Download'
  },
  Alerta: {
    QuienesSomos: 'In TrArtist the protagonists are the Artists and Designers, creative geniuses, imaginers of conversations between their ideas, their soul and the audience, creators of magic that make us dream and vibrate, sigh to have that work of art in our home, inspire us with the music, books, a wonderful dance video or imagining ourselves with an ideal garment or jewel with which we highlight all our beauty and power, ideas that produce security and make us feel unique, not in uniform, because we are millions, and millions are the ideas, dazzle the world with your way of being, your style, what you wear, think and fill your life with charm, gatherings, conversations, explorations, searches, discoveries, that is what we do at TrArtist "',
    QuienesSomos2: '"Symbiosis of art and design lovers with the creators of magic"',
    VerMas: 'See more',
    EliminarProducto: 'Are you sure you want to delete the Product?',
    ProductoEliminado: 'The product has been deleted',
    AlIngresar: 'By entering TrArtist.com you accept our',
    Entendido: 'Agreed',
    PostulacionExitosa: 'Your presentation has been sent successfully',
    RegistroExitoso: 'You have successfully registered',
    SesionCerrada: 'See you soon',
    IniciarSesion: 'You have successfully logged in',
    CodigoIncorrecto: 'The code is wrong',
    NoAprobado: 'You have not yet been approved.',
    FaltaInformacion: 'Fill in the information to continue',
    NoCoincide: 'Email and code do not match',
    Rechazado: 'Your submission has been rejected',
    UsuarioActualizado: 'Your profile information has been updated',
    ProductoPublicado: 'Product successfully published',
    ProductoEnAprobacion: 'Your Product is in approval, we will notify you by email when it has been reviewed',
    ArticuloPublicado: 'Article published correctly',
    NombreEnUso: 'Username in use, choose another',
    SinMeGusta: 'Login to save as Favorite',
    InformacionActualizada: 'Information Updated Correctly',
    ImagenCargada: 'Image Loaded, Press Update to reflect the changes on the web',
    ConfirmarEmail: 'We have sent you an email to confirm your subscription',
    EmailRegistrado: 'Email is already registered',
    ProductoAnadido: 'Product Added Correctly',
    PerfilEliminado: 'Your Profile has been successfully removed',
    MensajeEnviado: 'Your message has been sent successfully',
    ReestablecerContrasena: 'We have sent you an email to reset your password',
    IntroduceEmail: 'Enter your email to recover the password',
    Proximamente: 'Soon',
    CorreoEnviado: 'Mail successfully sent',
    EresRobot: 'Our system detected suspicious activity, if you are human please try again.',
    TarjetaVencida: 'Your Card is expired',
    Copiado: 'Copied Link, Paste it on your favorite social network or send it by mail',
    MeGusta: 'Added to Favorites, you can see it in your profile later',
    NoMeGusta: 'Product has been removed from Favorites',
    InformacionPublicada: 'Correctly Published Information',
    InformacionEliminada: 'Information successfully deleted',
    AdjuntaImagenes: 'Attach Images of your Work before applying',
    Desuscrito: 'You will no longer receive emails from TrArtist',
    GuiaRequerida: 'Guide number, Transportadora and Evidence is required',
    EnvioActualizado: 'Shipping has been updated',
    PagoExitoso: 'Payment has been successful',
    CorreoEnUso: 'The mail is already in use'
  },
  Pago: {
    Selecciona: 'Select your Payment Method',
    OtroMedio: 'Choose Another Payment Method',
    Nombre: 'Full name',
    Email: 'Email',
    Telefono: 'Phone',
    General: 'General information',
    Pago: 'Payment',
    MedioDePago: 'Payment method',
    Siguiente: 'Next',
    Atras: 'Back',
    TipoDocumento: 'Document type',
    NumeroDocumento: 'Document number',
    Pagar: 'Pay',
    Banco: 'Choose Bank',
    MismaInformacion: 'Fill with billing information',
    NombreTitular: 'Name of owner',
    TipoDeCliente: 'Customer type',
    Confirmacion: 'Confirmation',
    TiposDocumento: {
      CC: '[CC] Citizenship card',
      CE: '[CE] Foreigner ID',
      NIT: '[NIT] Business',
      TI: '[TI] Identity card',
      PP: '[PP] Passport',
      CEL: '[CEL] Telephone, if identified through the mobile line',
      RC: '[RC] Birth certificate',
      DE: '[DE] Foreign Identification Document'
    },
    MediosDePago: {
      Paypal: 'Paypal',
      TarjetaCredito: 'Credit Card',
      TarjetaDebito: 'Debit Card',
      Pse: 'PSE',
      Efectivo: 'Cash or Bank Consignment'
    },
    CreditCard: {
      Nombre: 'Card Holder',
      Numero: 'Card Number',
      Fecha: 'Year/Month',
      CodigoSeguridad: 'CVV'
    },
    TipoCliente: {
      PersonaNatural: 'Natural person',
      PersonaJuridica: 'Legal person'
    }
  },
  Categoria: {
    // ARTISTAS
    Pintura: 'Painting',
    Painting: 'Pintura',
    Dibujo: 'Draw',
    Draw: 'Dibujo',
    Ilustracion: 'Illustration',
    Ilustración: 'Illustration',
    Illustration: 'Ilustración',
    EsculturaYTalla: 'Sculpture and Carving',
    Sculpture_and_Carving: 'Escultura Y Talla',
    Fotografia: 'Photography',
    Fotografía: 'Photography',
    Photography: 'Photography',
    Escritores: 'Writers',
    Writers: 'Escritores',
    Musicos: 'Musicians',
    Musicians: 'Musicos',
    Danza: 'Dance',
    Dance: 'Danza',
    Murales: 'Murals',
    Murals: 'Murales',
    Impresiones: 'Prints',
    Prints: 'Impresiones',
    Collage: 'Collage',
    Instalaciones: 'Installations',
    Installations: 'Instalaciones',
    Video: 'Video',
    Libro: 'Book',
    Book: 'Libro',
    Otros: 'Others',
    Others: 'Otros',
    // DISEÑADORES
    Moda: 'Fashion',
    Fashion: 'Moda',
    Joyas: 'Jewelry',
    Jewelry: 'Joyas',
    Ceramica: 'Ceramics',
    Cerámica: 'Ceramics',
    Ceramics: 'Ceramica',
    Artesania: 'Crafts',
    Crafts: 'Artesania',
    Mobiliario: 'Furniture',
    Furniture: 'Mobiliario',
    ObjetosDecoracion: 'Decoration objects',
    Decoration_objects: 'Objetos de Decoración',
    Invitado: 'Invited',
    Invited: 'Invitado',
    Editorial: 'TrArtist Editorial',
    TrArtist_Editorial: 'Editorial',
    Stories: 'Stories',
    Todos: 'All',
    All: 'Todos',
    // ESTILOS
    Abstracto: 'Abstract',
    Conceptual: 'Conceptual',
    Figurativo: 'Figurative',
    Geometrico: 'Geometric',
    Minimalista: 'Minimalist',
    Moderno: 'Modern',
    Paisaje: 'Landscape',
    Animales: 'Animals',
    Fantasia: 'Fantasy',
    Realismo: 'Realism',
    PopArt: 'Pop Art',
    Retrato: 'Portrait',
    Surrealismo: 'Surrealism',
    Tipografico: 'Typographic',
    Urbano: 'Urban',
    ArteCallejero: 'Street art',
    Comic: 'Comic',
    // Orientación
    Cuadrado: 'Square',
    Todo: 'All',
    Fisico: 'Physical',
    Digital: 'Digital',
    // Colores
    NoAplica: 'Not apply',
    Multicolor: 'Multicolor',
    Amarillo: 'Yellow',
    Azul: 'Blue',
    Rojo: 'Red',
    Verde: 'Green',
    Negro: 'Black',
    Blanco: 'White',
    Gris: 'Gray',
    Rosado: 'Pink',
    Fucsia: 'Fuchsia',
    Magenta: 'Magenta',
    Lila: 'Lilac',
    Morado: 'Purple',
    Violeta: 'Violet',
    Naranja: 'Orange',
    Plateado: 'Silver',
    Dorado: 'Gold',
    Cobre: 'Copper',
    Bronce: 'Bronze',
    Cafe: 'Brown',
    BlancoNegro: 'Black and White'
  },
  Mes: {
    Enero: 'January',
    Febrero: 'February',
    Marzo: 'March',
    Abril: 'April',
    Mayo: 'May',
    Junio: 'June',
    Julio: 'July',
    Agosto: 'August',
    Septiembre: 'September',
    Octubre: 'October',
    Noviembre: 'November',
    Diciembre: 'December'
  },
  Busqueda: {
    Color: 'Color',
    OrdenarPor: 'Sort by',
    PrecioMenor: 'Low to High',
    PrecioMayor: 'High to Low',
    Formato: 'Format',
    Fisico: 'Physical',
    Digital: 'Digital',
    Ambas: 'Both',
    Titulo: 'Title',
    Largo: 'L',
    Ancho: 'W',
    Alto: 'H',
    Peso: 'W',
    PesoNormal: 'Weight',
    PesoEnrollado: 'Rolled weight',
    Historial: 'HISTORY',
    Disponibles: 'Available',
    UnidadesIlimitadas: 'Unlimited Units',
    UnidadesDisponibles: 'Units available',
    Vendidos: 'Sold',
    Agotado: 'Sold out',
    Carrito: 'Add to Bag',
    PrecioFisico: 'Physical Price',
    PrecioDigital: 'Digital Price',
    PaisDeOrigen: 'Country of origin',
    Categoria: 'Category',
    Orientacion: 'Orientation',
    Estilo: 'Style',
    Buscar: 'Search',
    Precio: 'Price',
    NoAplica: 'Not Apply'
  },
  Club: {
    Club: 'TrArtist Club',
    Subtitulo1: 'If you are a TrArtist Designer or Artist, you are already part of the Club.',
    Subtitulo2: 'We will add you to our private Facebook group TrArtist Club, through which we will communicate.',
    Texto1: 'We want to create community, lets build stories that are sources of knowledge and inspiration, lets create artistic and design movements, lets support each other, collaborate, think and think together.',
    Texto2: 'We will organize talks, gatherings, meetings between designers and artists and talks with stakeholders (clients and lovers of arts and design)'
  },
  Oficina: {
    OtroValor: 'Other Value',
    CodigoProducto: 'Product Code',
    PagosRecibidos: 'Received Payments',
    CodigoPedido: 'Order Code',
    Referencia: 'Reference',
    FechaVenta: 'Sale Date',
    Producto: 'Product',
    Fecha: 'Date',
    Estado: 'State',
    Valor: 'Value',
    Acciones: 'Actions',
    SolicitarPago: 'Request Payment',
    Pagos: 'Payments',
    EnviarSoporte: 'Send',
    TipoSolicitud: 'Type of request',
    Descripcion: 'Description',
    Nombre: 'Full Name',
    Email: 'Email',
    Asunto: 'Subject',
    Mensaje: 'Message',
    Enviar: 'Send',
    Talla: 'Size',
    Cantidad: 'Quantity',
    Tallas: 'Sizes',
    NuevaTalla: 'New Size',
    EditarTalla: 'Edit Size',
    Color: 'Color',
    NuevaUnidad: 'New Unit',
    TallasYColores: 'Sizes and Colors',
    EditarUnidad: 'Edit Unit',
    Ventas: 'Sales',
    AnadirTalla: 'Add Size',
    AnadirUnidad: 'Add Unit',
    TituloColor: 'Color Title',
    NuevoColor: 'New color',
    Colores: 'Colors',
    Inventario: 'Inventory',
    // NuevaVariacion: 'New Variation',
    NuevaVariacion: 'Add Quantity',
    ActualizarColor: 'Update Color',
    ActualizarTalla: 'Update Size',
    ActualizarVariacion: 'Update Variation',
    InventarioTotal: 'Total Inventory (Read Only)'
  },
  Empresas: {
    Nombre: 'Full Name',
    Email: 'Email',
    Asunto: 'Subject',
    Mensaje: 'Message',
    Enviar: 'Send',
    Pais: 'Country'
  },
  Inicio: {
    DescubreArtistas: 'Discover Artists',
    DescubreDisenadores: 'Discover Designers',
    Magazine: 'Magazine',
    VolverMagazine: 'Back to Magazine',
    LeerArticulo: 'Read Article',
    Favorito: 'Add to My Favorites',
    VerProducto: 'See Product',
    Compartir: 'Share',
    Equipo: 'Team',
    Pwa: 'Add the TrArtist App, Amazing!',
    PwaSafari: `Add the TrArtist App from Google Chrome, Amazing!`,
    Instalar: 'Install',
    DerechosReservados: 'All Rights Reserved'
  },
  Carrito: {
    Fecha: 'Date',
    Horario: 'Hours',
    Pasajeros: 'Passengers',
    Preferencias: 'Preferences',
    MisPedidos: 'My Orders',
    Aprobado: 'Payment Approved',
    Pendiente: 'Pending Payment',
    Rechazado: 'Payment Rejected',
    MensajePedido: 'You can check the order in your Profile',
    Remover: 'Remove',
    Productos: 'Products',
    Informacion: 'Information',
    Pago: 'Pay',
    CodigoPromocional: 'Promotional Code or Gift Card',
    Aplicar: 'Validate Code',
    TiempoDeEnvio: '*Shipping time varies depending on the country of origin and destination',
    Continuar: 'Continue',
    CalcularCosto: 'Calculate shipping cost',
    NoHayProductos: 'You have not added products yet',
    IniciaSesion: 'Login or Register to continue with the purchase',
    Acceso: 'Access',
    Registro: 'Registry',
    Correo: 'Email',
    Contrasena: 'Password',
    IniciarSesion: 'Log in',
    Registrarse: 'Register',
    CuponUsado: 'The coupon has already been used',
    Descuento: 'Discount',
    Resumen: 'Summary',
    DireccionDeEnvio: 'Shipping Address',
    Envio: 'Shipping',
    SolicitarAsesoria: 'Request Advice',
    MediosDePago: 'Payment methods',
    TarjetaCredito: 'Credit card',
    Efectivo: 'Cash',
    PagarPaypal: 'Pay with Paypal',
    // NUEVOS (REVISAR)
    RespaldoPayU: 'With the support of PayU',
    Bancos: 'Payment in Banks',
    Valor: 'Value',
    Descripcion: 'Description',
    MedioDePago: 'Payment method',
    Sucursal: 'Branch office',
    Pagar: 'Pay',
    NombreTarjeta: 'Card Holder',
    NumeroTarjeta: 'Card Number',
    CodigoSeguridad: 'Security code',
    FechaVencimiento: 'Expiration date',
    Mes: 'Month',
    Ano: 'Year',
    PrecioEnvioNacional: 'National shipping price',
    EnvioGratis: 'My product includes the shipping cost of shipping to the whole world.',
    ResumenCompra: 'Summary of your purchase'
  },
  PayU: {
    MedioDePago: 'Payment method',
    Credito: 'Credit card',
    Debito: 'Debit card',
    Pse: 'Bank Transfer (PSE)',
    Efectivo: 'Cash',
    Banco: 'Bank payment',
    InformacionDePago: 'Payment information',
    LlenarInfo: 'Complete Information with Shipping Data',
    NombreCompleto: 'Full name',
    EmailAddress: 'Email',
    ContactPhone: 'Phone',
    TipoDeDocumento: 'Document type',
    CC: 'Citizenship card',
    CE: 'Foreigner ID',
    NIT: 'Tax Identification Number',
    TI: 'Identity card',
    PP: 'Passport',
    IDC: 'Unique Customer Identifier',
    CEL: 'Phone',
    RC: 'Birth certificate',
    DE: 'Foreign Identification Document',
    NumeroDeDocumento: 'Document number',
    Pais: 'Country',
    Departamento: 'Department',
    Ciudad: 'City',
    Direccion: 'Address',
    CodigoPostal: 'Postal Code',
    NombreTarjeta: 'Card Holder',
    NumeroTarjeta: 'Card Number',
    CodigoSeguridad: 'Security code',
    FechaVencimiento: 'Expiration date',
    FechaVencimientoHint: 'YYYY/MM'
  },
  Faq: {
    Compromisos: 'TrArtist commitments'
  },
  Asesoria: {
    Titulo1: 'Selected Artists and Designers',
    Descripcion1: 'Our designers and artists have gone through a selection process',
    Titulo2: 'Free advice',
    Descripcion2: 'A curator or advisor will support you, if you wish, to make a purchase according to your needs.',
    Titulo3: 'Purchase satisfaction',
    Descripcion3: 'We guarantee the money back if the product does not correspond to the one we offered you on www.trartist.com, or if it has any damage or defect.',
    Titulo4: 'Curatorship or Consulting',
    Descripcion4: 'At TrArtist we know that on many occasions we want support in a purchase of a work of art or a design object or in a design garment, either because we have another opinion or another look at our need or because we simply do not know which option to choose of so many possible options. The curatorship will help you find what you want on TrArtist, also for business services, art, design or custom-designed products.',
    PreFormulario: 'We have this curatorship, free advice, write to us telling us your need and we will support you as soon as possible. Send us the following form',
    Descripcion: 'Tell us what advice do you need?',
    SolicitarAsesoria: 'Request Advice'
  },
  Envios: {
    Descripcion: 'Products purchased through TrArtist will be sent to the delivery address you indicated and within the stipulated deadlines.'
  },
  Administracion: {
    Letra: 'Letter',
    Fondo: 'Background',
    NuevaImagen: 'New Image',
    Aprobar: 'Approve',
    Rechazar: 'Reject',
    Pendientes: 'Slopes',
    Finalizados: 'Finished'
  },
  Regalo: {
    Horario: 'Hours',
    NumeroPasajeros: 'Passengers Number',
    Preferencias: 'Preferences',
    ReservaTour: 'Reserve a Tour',
    FechaRequerido: 'Date Required',
    PasajerosRequerido: 'Passengers Number Required',
    PreferenciasRequerido: 'Preferences Required',
    HorarioRequerido: 'Hours Required',
    ValorRequerido: 'Required Value',
    NombreRequerido: 'Name Required',
    CorreoRequerido: 'email Required',
    IdiomaRequerido: 'Language Required',
    CorreoRecibe: 'Mail from who receives',
    IdiomaRecibe: 'Language of who receives',
    Descripcion: 'It will be a wonderful surprise for those who receive this gift card, have the possibility to choose a unique and very special gift, artwork or design.',
    Arma: 'Assemble your gift',
    Instrucciones: 'Select a value or personalize it, write a message, choose the image you like the most and we will send it by email immediately.',
    OtraCantidad: 'Other Amount',
    Mensaje: 'Write a message for that special person',
    Msj: 'Message',
    Codigo: 'Code',
    Cantidad: 'Amount',
    De: 'From',
    Para: 'For',
    es: 'Spanish',
    en: 'English',
    Es: 'Spanish',
    En: 'English'
  },
  Pagos: {
    Codigo: 'Code',
    Categoria: 'Category',
    Nombre: 'Name',
    Fecha: 'Date',
    Referencia: 'Reference',
    ValorVenta: 'Sale Value',
    ValorPago: 'Payment value',
    Comprobante: 'Voucher',
    AdjuntarComprobante: 'Attach Proof of Payment',
    ComprobantePago: 'UPLOAD PROOF OF PAYMENT',
    SeleccionComprobante: '* You must select a proof of payment in order to update the data'
  },
  Email: {
    TextoNewsletter: '<span>Hello {nombre},</span><br><br><span>Welcom to TrArtist, <a href="https://trartist.com/confirmarnewsletter/{uid}">Click here</a> to confirm your subscription</span><br><br><span>sincerely,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoVentas: 'Your product {titulo} has been shipped',
    TextoVentas: '<span>Hello {nombre}</span><br><br><span>your product {titulo} has been sent with the Guide number {guia} through {transportadora}</span><br><br><span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoPagos: 'Your product {titulo} reference {uid} has been payment',
    TextoPagos: '<span>Hello {nombre}</span><br><br><span>Product payment has been made {titulo} reference {uid} You can check it in your backOffice in your TrArtis profile, in addition pdf file with proof of payment is attached</span><br><br><span>Regards ,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoAprobado: 'Your TrArtist Application Has Been Approved',
    TextoAprobado: '<span>Hello {nombre},</span><br><br><span>Welcome to TrArtist, Your TrArtist Application Has Been Approved, You can now enter TrArtist and register as an Artist or Designer with the code: {codigo}</span><br><br><span>1.To know our conditions and how we work, register as an artist or designer with the code you received. When you access the backoffice, you will be able to know and access all the information related to how we work, how is the relationship between vendors (artists and / or designers) and TrArtist. At this point you have no obligation or contract, you have not accepted anything, it only gives you access to know our operation. If you do not agree with our Terms or have doubts and concerns, you can delete your registration, not continue with the process or you can contact us at yoquiero@trartist.com or call or write us by whatsapp at +57 3213025754 Bogotá - Colombia. We will gladly help you.</span><br><br><span>2. Review the first point of the trainings, there you can find the entire process that you must follow and all the details of our operation. We hope that you are a member of TrArtist and together we can build a wonderful community of growth, innovation, creativity and successful partnerships and businesses.</span><br><br><span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoRechazado: 'Your application in TrArtist has not been successful',
    TextoRechazado: '<span>Hello {nombre},</span><br><br><span>Your application in TrArtist has not been successful.</span><br><br><span>{comentario}</span><br><br><span>Regards,</span><br><span><b>TrArtist Team</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoVentasProducto: 'Successful purchase',
    TextoVentasProducto: '<span>Below is the summary of your purchase: </span><br>',
    Producto: 'Product',
    CosteEnvio: 'Cost of shipping',
    TotalProducto: 'Price',
    Cantidad: 'Quantity',
    Tipo: 'Type'
  },
  Acceso: {
    TerminosYcondiciones: 'See terms and conditions'
  },
  Correo: {
    Producto: 'Product',
    CosteEnvio: 'Cost of shipping',
    TotalProducto: 'Total product',
    Cantidad: 'Amount',
    Tipo: 'Type',
    TotalPurchase: 'Total purchase',
    Date: 'Date'
  }
}
